/* RESPONSIBLE TEAM: team-automation-foundations */
import type SetUserDataAttribute from 'embercom/models/operator/visual-builder/step/set-user-data-attribute';
import StepConfig, { type StepConfigParams } from '../step';

export default class SetUserDataAttributeConfiguration extends StepConfig {
  declare step: SetUserDataAttribute;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/set-user-data-attribute/editor',
      ...params,
    });
  }
}
